import * as angular from 'angular';
import { AuthService } from 'app/_services/auth.service';

(function () {
    'use strict';

    angular.module('app').controller('ReportingCtrl', ReportingCtrl);

    /**
     * A general controller for the reporting page managing the underlying views.
     *
     * @author flzemke.btc
     * @ngInject
     *
     * THIS IS NOT USED ANYMORE FOR AUCTIONS, SECONDARY and CAPACITY LINKING
     * TODO remove this for the other pages as well when migrating to angularjs components
     */
    function ReportingCtrl(
        reportingService,
        $routeParams,
        $location,
        authService: AuthService
    ) {
        var vm = this;
        vm.REPORT = reportingService.REPORT;
        vm.currentReport = {};

        authService.userLoginPromise.promise
            .then((loggedInUser) => {
                if ($routeParams.reportType != null) {
                    vm.currentReport =
                        reportingService.REPORT[
                            $routeParams.reportType.toUpperCase()
                        ];
                } else if (
                    loggedInUser.role === 'SHIPPER_USER' ||
                    loggedInUser.role === 'SHIPPER_ADMIN'
                ) {
                    $location.path('/reporting/standard').replace();
                } else if (loggedInUser.role === 'TSO_USER') {
                    $location.path('/reporting/auction').replace();
                }
            })
            .catch(() => {
                if ($routeParams.reportType != null) {
                    vm.currentReport =
                        reportingService.REPORT[
                            $routeParams.reportType.toUpperCase()
                        ];
                } else {
                    $location.path('/reporting/standard').replace();
                }
            });
    }
})();
